var _path, _path2, _path3, _path4, _rect, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpcoming(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0C8.94508 0 0 8.94586 0 20C0 31.0549 8.94586 40 20 40C31.0549 40 40 31.0541 40 20C40 8.94508 31.0541 0 20 0Z",
    fill: "#1A89A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 20C1 9.49812 9.49739 1 20 1V-1C8.39277 -1 -1 8.3936 -1 20H1ZM20 39C9.49812 39 1 30.5026 1 20H-1C-1 31.6072 8.3936 41 20 41V39ZM39 20C39 30.5019 30.5026 39 20 39V41C31.6072 41 41 31.6064 41 20H39ZM20 1C30.5019 1 39 9.49739 39 20H41C41 8.39277 31.6064 -1 20 -1V1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29 15.7812V14.375C29 13.3398 28.1362 12.5 27.0714 12.5H25.1429V10.4688C25.1429 10.2109 24.9259 10 24.6607 10H23.0536C22.7884 10 22.5714 10.2109 22.5714 10.4688V12.5H17.4286V10.4688C17.4286 10.2109 17.2116 10 16.9464 10H15.3393C15.0741 10 14.8571 10.2109 14.8571 10.4688V12.5H12.9286C11.8638 12.5 11 13.3398 11 14.375V15.7812C11 16.0391 11.217 16.25 11.4821 16.25H28.5179C28.783 16.25 29 16.0391 29 15.7812Z",
    fill: "#F9B42A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5179 17.5H11.4821C11.217 17.5 11 17.7109 11 17.9688V28.125C11 29.1602 11.8638 30 12.9286 30H27.0714C28.1362 30 29 29.1602 29 28.125V17.9688C29 17.7109 28.783 17.5 28.5179 17.5Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 19,
    width: 4,
    height: 4,
    rx: 1,
    fill: "#FFCC66"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 24,
    width: 4,
    height: 4,
    rx: 1,
    fill: "#FFCC66"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpcoming);
export default __webpack_public_path__ + "static/media/upcoming.8f913518.svg";
export { ForwardRef as ReactComponent };